/* eslint-disable no-unused-vars */
/** @format */

// import {filter} from 'lodash';
import React, { useState, useEffect } from "react";
// material
import {
  Button,
  Card,
  Container,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
  CircularProgress,
} from "@mui/material";
// components
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import SearchToolbar from "../../reusables/table/SearchToolbar";
import SortableTableHeader from "../../reusables/table/SortableTableHeader";
//
// import NumberMoreMenu from "./NumberMoreMenu";
import { useNavigate } from "react-router-dom";
import Iconify from "../../components/Iconify";
import {
  applySortFilter,
  getComparator,
} from "../../reusables/table/SortFilterUtils";
import SearchNotFound from "../../components/SearchNotFound";
// import TableMenuDropdown from "../../reusables/table/TableMenuDropdown";
// import TableMenuItem from "../../reusables/table/TableMenuItem";
import PhoneNumber from "../../dao/PhoneNumber";
import Waba from "../../dao/Waba";
import Cost from "../../dao/Cost";
import Select from "react-select";
import swal from "../../reusables/CustomSwal";

import qs from "qs";
import { useLocation } from "react-router";
import { blacklistUser } from "../../static/blacklist";
import { useSelector } from "react-redux";

import CreateCostMasterDialog from "./CreateCostMasterDialog";
import UpdateCostMasterDialog from "./UpdateCostMasterDialog";
// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: "count", label: "No.", alignRight: false },
  { id: "waba_id", label: "Waba ID", alignRight: false },
  { id: "tenant_id", label: "Tenant", alignRight: false },
  { id: "phone_number", label: "Phone Number", alignRight: false },
  { id: "cost_user", label: "Cost User", alignRight: false },
  {
    id: "cost_business_utility",
    label: "Cost Business Utility",
    alignRight: false,
  },
  {
    id: "cost_business_authentication",
    label: "Cost Business Authentication",
    alignRight: false,
  },
  {
    id: "cost_business_marketing",
    label: "Cost Business Marketing",
    alignRight: false,
  },
  { id: "config", label: "", alignRight: false },
];

const TABLE_HEAD_BLACKLIST = [
  { id: "count", label: "No.", alignRight: false },
  { id: "phone_num", label: "Phone Broadcast", alignRight: false },
  { id: "verified_name", label: "Verified Name", alignRight: false },
];

// ----------------------------------------------------------------------
export default function CostMasterList(props) {
  let user = useSelector(({ auth }) => auth.auth);
  const navigate = useNavigate();
  const location = useLocation();
  let email = useSelector(({ auth }) => auth?.auth?.email);
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  let idParam = queryParams.waba_id;
  const [addingWaba, setAddingWaba] = useState(false);
  const [updateWaba, setUpdateWaba] = useState(false);

  const [details, setDetails] = useState([]);
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("F");
  const [filterName, setFilterName] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [cost, setCost] = useState([]);
  const [isDataFetched, setIsDataFetched] = useState(false);

  const [wabaOptions, setWabaOptions] = useState([]);
  const [selectedWabaId, setSelectedWabaId] = useState(null);
  const [selectedWabaLabel, setSelectedWabaLabel] = useState(null);

  // console.log("selectedWabaId", selectedWabaId);
  const getCost = async () => {
    try {
      navigate("?waba_id=" + selectedWabaId);

      let result = await Cost.getCostByWABAID(selectedWabaId);
      // console.log(result);
      setCost(result);
      setIsDataFetched(true);
    } catch (e) {
      console.log("ERROR", e);
      await swal.fire({
        title: "Error",
        text: "An error has occurred. Please try again later.",
        icon: "error",
      });
    }
  };

  const getWabas = async () => {
    try {
      let result = await Waba.getMyWaba();
      // console.log(result);
      //let templates = result.map((el) => ({...el.profile, role: el.role}));

      let formatted = result.map((obj) => {
        return {
          label: `${obj.name} (${obj.waba_id})`,
          value: obj.waba_id,
        };
      });

      if (formatted.length > 0) {
        let wabaFromParam = formatted.find((obj) => obj.value === idParam);

        if (wabaFromParam && idParam) {
          setSelectedWabaId(wabaFromParam.value);
          setSelectedWabaLabel(wabaFromParam.label);
        } else {
          setSelectedWabaId(formatted[0].value);
          setSelectedWabaLabel(formatted[0].label);
        }
      }

      setWabaOptions(formatted);
    } catch (e) {
      // nothing
    }
  };

  useEffect(() => {
    getWabas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    // console.log("UE", selectedWabaId);
    if (selectedWabaId !== null) {
      getCost();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedWabaId]);

  let count = page * rowsPerPage + 1;

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    count = page * rowsPerPage + 1;
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  //   const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage) : 0;
  const filteredData = applySortFilter(
    cost,
    getComparator(order, orderBy),
    filterName,
    "waba_id"
  );
  const notFound = filteredData.length === 0;

  // const checkBlackList = !blacklistUser.some((item) => item === email);

  return (
    <Page title="WhatsApp Numbers">
      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Cost Master
          </Typography>
          {user.role === "SUPER_ADMIN" && (
            <Button
              variant="contained"
              onClick={() => {
                setAddingWaba(true);
              }}
              startIcon={<Iconify icon="akar-icons:plus" />}
            >
              New Cost Master
            </Button>
          )}
        </Stack>

        <Stack
          style={{
            marginBottom: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          direction="row"
        >
          <small>Filter by Waba ID :</small>
          <div style={{ width: 300 }}>
            <Select
              onChange={(option) => {
                // console.log(option);
                setSelectedWabaId(option.value);
                setSelectedWabaLabel(option.label);
              }}
              value={{
                label: selectedWabaLabel,
                value: selectedWabaId,
              }}
              options={wabaOptions}
            />
          </div>
        </Stack>

        {wabaOptions.length > 0 && (
          <Card>
            <SearchToolbar
              filterName={filterName}
              onFilterName={handleFilterByName}
            />

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table style={{ backgroundColor: "white", color: "white" }}>
                  <SortableTableHeader
                    order={order}
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    onRequestSort={handleRequestSort}
                  />
                  <TableBody>
                    {filteredData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row) => {
                        const {
                          id,
                          waba_id,
                          tenant_id,
                          phone_number,
                          cost_user,
                          cost_business_utility,
                          cost_business_authentication,
                          cost_business_marketing,
                        } = row;
                        // const phoneNum = display_phone_number.replace(
                        //   /\D/g,
                        //   ""
                        // );
                        return (
                          <TableRow
                            hover
                            key={row.id}
                            tabIndex={-1}
                            role="checkbox"
                          >
                            <TableCell align="left">{count++}</TableCell>
                            <TableCell align="left">{waba_id}</TableCell>
                            <TableCell align="left">{tenant_id}</TableCell>
                            <TableCell align="left">{phone_number}</TableCell>
                            <TableCell align="left">{cost_user}</TableCell>
                            <TableCell align="left">
                              {cost_business_utility}
                            </TableCell>
                            <TableCell align="left">
                              {cost_business_authentication}
                            </TableCell>
                            <TableCell align="left">
                              {cost_business_marketing}
                            </TableCell>

                            <TableCell align="right">
                              <Button
                                onClick={() => {
                                  setUpdateWaba(true);
                                  setDetails(row);
                                }}
                              >
                                Edit
                              </Button>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    {/*{emptyRows > 0 && (*/}
                    {/*  <TableRow style={{height: 53 * emptyRows}}>*/}
                    {/*    <TableCell colSpan={6}/>*/}
                    {/*  </TableRow>*/}
                    {/*)}*/}
                  </TableBody>
                  {(notFound || !isDataFetched) && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          {!isDataFetched ? (
                            <CircularProgress />
                          ) : (
                            <SearchNotFound searchQuery={filterName} />
                          )}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 20, 50, 100]}
              component="div"
              count={cost.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
            <CreateCostMasterDialog
              waba={idParam}
              open={addingWaba}
              onClose={(refresh) => {
                setAddingWaba(false);
                if (refresh) {
                  getWabas();
                }
              }}
            />
            <UpdateCostMasterDialog
              details={details}
              open={updateWaba}
              onClose={(refresh) => {
                setUpdateWaba(false);
                if (refresh) {
                  getWabas();
                }
              }}
            />
          </Card>
        )}
      </Container>
    </Page>
  );
}
